var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", "no-margin": "" } },
    [
      _vm._l(_vm.mails, function (mail, i) {
        return _c(
          "w-row",
          { key: i, style: { flexGrow: 1 } },
          [
            _c(
              "w-col",
              [
                _c(
                  "w-row",
                  { staticClass: "mail-row", attrs: { "no-margin": "" } },
                  [
                    _c("w-input", {
                      ref: "inputs",
                      refInFor: true,
                      staticClass: "email-input",
                      class: { error: !_vm.isEmailAddressValid(mail) },
                      attrs: {
                        value: _vm.mails[i].address,
                        label: _vm.getMailLabel(i),
                        autocapitalize: "none",
                        autocomplete: "off",
                        fancy: "",
                        icon: "cog",
                        "icon-tooltip": _vm.$ct("edit-email-address-settings"),
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onMailInput(mail, $event)
                        },
                        "icon-click": function ($event) {
                          return _vm.editMailSettings(i)
                        },
                        keydown: function ($event) {
                          return _vm.onKeyDown($event)
                        },
                        blur: function ($event) {
                          mail.wasBlured = true
                        },
                      },
                    }),
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("remove-email-address"),
                            expression: "$ct('remove-email-address')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeEmailAddress(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-row",
        { style: { marginTop: 0, paddingTop: 0 } },
        [
          _c(
            "w-col",
            { style: { marginTop: 0, paddingTop: 0 } },
            [
              _c(
                "w-link",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addEmailAddress()
                    },
                  },
                },
                [
                  _c("w-fa", { attrs: { icon: "plus" } }),
                  _vm._v(" " + _vm._s(_vm.$ct("add-email-address"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditMailSettings
        ? _c("app-contact-edit-address-email-settings", {
            attrs: {
              value: _vm.toEditMailSettings,
              "is-default":
                _vm.toEditMailSettingsIndex == _vm.defaultSettingsIndex,
              "is-default-for-reminder":
                _vm.toEditMailSettingsIndex == _vm.defaultReminderSettingsIndex,
              "group-id": _vm.groupId,
            },
            on: {
              close: function ($event) {
                _vm.toEditMailSettingsIndex = -1
              },
              input: function ($event) {
                return _vm.setMailSettings($event)
              },
              "set-is-default": function ($event) {
                return _vm.setDefaultMail($event)
              },
              "set-is-default-for-reminder": function ($event) {
                return _vm.setDefaultForReminders($event)
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }